import React from "react";
import styled from "styled-components";
import DashFooter from "./DashFooter";
import { RxDotFilled } from "react-icons/rx";
import avatar from "../assets/avatar.png";
import { Link } from "react-router-dom";

const Overview = ({ isOpen }) => {
  return (
    <OverviewMain>
      <h3>Dashboard Overview</h3>
      <OverviewPara>
        This dashboard to manage billing & customer support
      </OverviewPara>
      <CardOverview>
        <CardHeader>
          <div>
            <h4>
              <RxDotFilled className="icon" />
              Active
            </h4>
          </div>
          <div>
            <span>Free</span>
          </div>
        </CardHeader>
        <CardFlex>
          <CardData>
            <h5>
              <div className="icon">
                <img src={avatar} alt="" />
              </div>
              Enhance Your Experience
            </h5>
            <p>
              Upgrade to manage your finance more easily with advanced modules &
              features or you can request custom requirement.
            </p>
            <div className="button">Upgrade</div>
          </CardData>
          <CardData>
            <h5>
              <div className="icon">
                <img src={avatar} alt="" />
              </div>
              Visit the Money Manager dashboard
            </h5>
            <p>
              To use all the features & modules of the software click the button
              down below you will redirect to the dashboard of Money Manager.
            </p>
            <Link to="#">
              <div className="button">Click to Visit</div>
            </Link>
          </CardData>
        </CardFlex>
        <ul>
          <li>
            <p>Version</p>
            <h4>1.0.5</h4>
          </li>
          <li>
            <p>Region</p>
            <h4>India</h4>
          </li>
          <li>
            <p>Tier</p>
            <h4>Free</h4>
          </li>
          <li>
            <p>Backups</p>
            <h4>Inactive</h4>
          </li>
        </ul>
      </CardOverview>
      <DashFooter isOpen={isOpen} />
    </OverviewMain>
  );
};

export default Overview;

const OverviewMain = styled.div`
  h3 {
    font-weight: 500;
    font-size: 35px;
    font-family: "Source Serif Pro", serif;
    color: rgb(0, 104, 74);
  }
`;

const OverviewPara = styled.p`
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  color: rgb(0, 30, 43);
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 25px;
  border-bottom: 1px solid #cfcfcf;

  h4 {
    font-weight: 500;
    font-size: 18px;
    color: rgb(0, 104, 74);
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      font-size: 32px;
      color: #00a35c;
      margin-right: -7px;
    }
  }
  span {
    font-weight: 500;
    font-size: 15px;
    color: rgb(0, 30, 43);
    padding: 3px 15px;
    border: 1px solid rgb(0, 30, 43);
    border-radius: 25px;
  }
`;

const CardFlex = styled.div`
  display: flex;

  @media only screen and (max-width: 991px) {
    display: flex;
    flex-direction: column;
  }
`;

const CardData = styled.div`
  padding: 30px 25px;
  width: 470px;
  h5 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: rgb(28, 45, 56);
    font-size: 20px;
    font-weight: 600;
    width: 100%;

    .icon {
      width: 32px;
      height: 32px;
      margin-right: 5px;
      background-color: #3aaa35;
      border-radius: 50%;
      position: relative;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 20px;
        height: 20px;
      }
    }
  }
  p {
    font-weight: 500;
    width: 100%;
    font-size: 15px;
    margin-top: 7px;
  }
  .button {
    padding: 3px 10px;
    background-color: #005800;
    width: 40%;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer;
  }
  @media only screen and (max-width: 991px) {
    padding: 30px 25px;
    width: 100%;
    h5 {
      font-size: 19px;
      width: 100%;

      .icon {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
      }
    }
    p {
      width: 100%;
    }
  }
`;

const CardOverview = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  margin-top: 15px;
  padding: 0px;
  border-radius: 8px;

  ul {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-top: 1px solid #cfcfcf;
    li {
      list-style: none;
      margin: 0px 20px;
      p {
        color: rgb(0, 104, 74);
        font-size: 12px;
      }
      h4 {
        font-size: 15px;
        font-weight: 500;
        color: rgb(0, 30, 43);
      }
    }
  }
`;
